// Auto-generated resource for Progress — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const ProgressKeys = {
  MasteryElement: {
    RateOfSpeech: 'Progress.MasteryElement.RateOfSpeech',
    Volume: 'Progress.MasteryElement.Volume',
    PitchAndMelody: 'Progress.MasteryElement.PitchAndMelody',
    Tonality: 'Progress.MasteryElement.Tonality',
    Pause: 'Progress.MasteryElement.Pause',
    FacialExpression: 'Progress.MasteryElement.FacialExpression',
    Gesture: 'Progress.MasteryElement.Gesture',
    EyeContact: 'Progress.MasteryElement.EyeContact',
  },
  Validations: {
    RequiresPremium: 'Progress.Validations.RequiresPremium',
  },
  Title: 'Progress.Title',
  MetaDescription: 'Progress.MetaDescription',
  Kicker: 'Progress.Kicker',
  Heading: 'Progress.Heading',
  Lead: 'Progress.Lead',
  Loading: 'Progress.Loading',
  LoadError: 'Progress.LoadError',
  TryAgain: 'Progress.TryAgain',
  LoadErrorToast: 'Progress.LoadErrorToast',
  StartCardHeading: 'Progress.StartCardHeading',
  StartCardBody: 'Progress.StartCardBody',
  StartPlan: 'Progress.StartPlan',
  Starting: 'Progress.Starting',
  StartError: 'Progress.StartError',
  AbandonedStatus: 'Progress.AbandonedStatus',
  DaysPractised: 'Progress.DaysPractised',
  DaysPractisedHint: 'Progress.DaysPractisedHint',
  DayDotsAria: 'Progress.DayDotsAria',
  ThisWeekHeading: 'Progress.ThisWeekHeading',
  RetainedHeading: 'Progress.RetainedHeading',
  RetainedReps: 'Progress.RetainedReps',
  RetainedCompetence: 'Progress.RetainedCompetence',
  WeekTrackHeading: 'Progress.WeekTrackHeading',
  WeekStateDone: 'Progress.WeekStateDone',
  WeekStateCurrent: 'Progress.WeekStateCurrent',
  WeekStateAhead: 'Progress.WeekStateAhead',
  AbandonedHint: 'Progress.AbandonedHint',
  StartNewPlan: 'Progress.StartNewPlan',
  PlanComplete: 'Progress.PlanComplete',
  WeekNow: 'Progress.WeekNow',
  WeekOf: 'Progress.WeekOf',
  DrillingInline: 'Progress.DrillingInline',
  LastDayThisWeek: 'Progress.LastDayThisWeek',
  OneDayLeft: 'Progress.OneDayLeft',
  DaysLeft: 'Progress.DaysLeft',
  DaysLeftAria: 'Progress.DaysLeftAria',
  WeeksCompletedAria: 'Progress.WeeksCompletedAria',
  WeekTitle: 'Progress.WeekTitle',
  ThisWeeksElement: 'Progress.ThisWeeksElement',
  DrillingElement: 'Progress.DrillingElement',
  PickElementHint: 'Progress.PickElementHint',
  AutoAdvanceNote: 'Progress.AutoAdvanceNote',
  RepTargetToAdvance: 'Progress.RepTargetToAdvance',
  ThisWeeksReps: 'Progress.ThisWeeksReps',
  RepCountOne: 'Progress.RepCountOne',
  RepCountMany: 'Progress.RepCountMany',
  Target: 'Progress.Target',
  RepsThisWeekAria: 'Progress.RepsThisWeekAria',
  RepsByDayAria: 'Progress.RepsByDayAria',
  RepHalfwayHint: 'Progress.RepHalfwayHint',
  ThisWeeksRecordings: 'Progress.ThisWeeksRecordings',
  SelectError: 'Progress.SelectError',
  GoBackAWeek: 'Progress.GoBackAWeek',
  GoBackConfirmTitle: 'Progress.GoBackConfirmTitle',
  GoBackConfirmCopy: 'Progress.GoBackConfirmCopy',
  Discard: 'Progress.Discard',
  Discarding: 'Progress.Discarding',
  Cancel: 'Progress.Cancel',
  GoBackError: 'Progress.GoBackError',
  EndPlan: 'Progress.EndPlan',
  EndPlanConfirmTitle: 'Progress.EndPlanConfirmTitle',
  EndPlanConfirmCopy: 'Progress.EndPlanConfirmCopy',
  Ending: 'Progress.Ending',
  EndPlanError: 'Progress.EndPlanError',
  StagesHeading: 'Progress.StagesHeading',
  StagesHint: 'Progress.StagesHint',
  WeeksDrilledSuffix: 'Progress.WeeksDrilledSuffix',
  RepsHeading: 'Progress.RepsHeading',
  LifetimeRepOne: 'Progress.LifetimeRepOne',
  LifetimeRepMany: 'Progress.LifetimeRepMany',
  AcrossPracticesOne: 'Progress.AcrossPracticesOne',
  AcrossPracticesMany: 'Progress.AcrossPracticesMany',
  AcrossPrefix: 'Progress.AcrossPrefix',
  NoRepsHint: 'Progress.NoRepsHint',
  PlanHistoryHeading: 'Progress.PlanHistoryHeading',
  AllMyPlans: 'Progress.AllMyPlans',
  NoWeeksHint: 'Progress.NoWeeksHint',
  WeekDates: 'Progress.WeekDates',
  PlanStarted: 'Progress.PlanStarted',
  CurrentPlanDates: 'Progress.CurrentPlanDates',
  PlanStartedNotice: 'Progress.PlanStartedNotice',
  HistoryCurrentPlan: 'Progress.HistoryCurrentPlan',
  HistoryPreviousPlan: 'Progress.HistoryPreviousPlan',
  TakeLabel: 'Progress.TakeLabel',
  HistoryRepsSuffix: 'Progress.HistoryRepsSuffix',
  StageHeldBelowTarget: 'Progress.StageHeldBelowTarget',
  NoRepSessions: 'Progress.NoRepSessions',
  AiReview: 'Progress.AiReview',
  LoadPlayback: 'Progress.LoadPlayback',
  NotePlaceholder: 'Progress.NotePlaceholder',
  Saving: 'Progress.Saving',
  Save: 'Progress.Save',
  EditNote: 'Progress.EditNote',
  AddNote: 'Progress.AddNote',
  SaveNoteError: 'Progress.SaveNoteError',
  NoRecordingRetained: 'Progress.NoRecordingRetained',
  DayMon: 'Progress.DayMon',
  DayTue: 'Progress.DayTue',
  DayWed: 'Progress.DayWed',
  DayThu: 'Progress.DayThu',
  DayFri: 'Progress.DayFri',
  DaySat: 'Progress.DaySat',
  DaySun: 'Progress.DaySun',
  DayFallback: 'Progress.DayFallback',
  PlanTakesHeading: 'Progress.PlanTakesHeading',
  PlanGroupCurrent: 'Progress.PlanGroupCurrent',
  PlanGroupHeld: 'Progress.PlanGroupHeld',
  KeepNeedsPremium: 'Progress.KeepNeedsPremium',
  KeepError: 'Progress.KeepError',
  PlanTakeActionError: 'Progress.PlanTakeActionError',
  Plans: {
    Heading: 'Progress.Plans.Heading',
    Lead: 'Progress.Plans.Lead',
    BackToProgress: 'Progress.Plans.BackToProgress',
    Loading: 'Progress.Plans.Loading',
    LoadError: 'Progress.Plans.LoadError',
    EmptyHeading: 'Progress.Plans.EmptyHeading',
    EmptyBody: 'Progress.Plans.EmptyBody',
    GoToProgress: 'Progress.Plans.GoToProgress',
    StatusActive: 'Progress.Plans.StatusActive',
    StatusCompleted: 'Progress.Plans.StatusCompleted',
    StatusEndedEarly: 'Progress.Plans.StatusEndedEarly',
    WeeksCompletedOne: 'Progress.Plans.WeeksCompletedOne',
    WeeksCompletedMany: 'Progress.Plans.WeeksCompletedMany',
  },
  WeekRepsSelfReviewedOne: 'Progress.WeekRepsSelfReviewedOne',
  WeekRepsSelfReviewedMany: 'Progress.WeekRepsSelfReviewedMany',
} as const;

export const ProgressValues = {
  'default': {
    'AbandonedHint': 'Auto-tracking and recording retention are paused. Start a new plan anytime; your competence and lifetime reps carry over.',
    'AbandonedStatus': 'Plan ended — your progress so far is kept.',
    'AcrossPracticesMany': 'practices',
    'AcrossPracticesOne': 'practice',
    'AcrossPrefix': 'across',
    'AddNote': 'Add a note',
    'AiReview': 'AI Review',
    'AllMyPlans': 'All my plans ›',
    'AutoAdvanceNote': 'Your week advances automatically after 7 days — just keep practising.',
    'Cancel': 'Cancel',
    'CurrentPlanDates': 'Started {Date} · Week {Week} · {Range}',
    'DayDotsAria': 'Days practised this week',
    'DayFallback': 'Day {Number}',
    'DayFri': 'Fri',
    'DayMon': 'Mon',
    'DaySat': 'Sat',
    'DaySun': 'Sun',
    'DayThu': 'Thu',
    'DayTue': 'Tue',
    'DayWed': 'Wed',
    'DaysLeft': '{Days} days left this week',
    'DaysLeftAria': 'Days left this week',
    'DaysPractised': '{Days} of {Total} days',
    'DaysPractisedHint': 'A day counts once you pass the halfway mark of any practice.',
    'Discard': 'DISCARD',
    'Discarding': 'Discarding…',
    'DrillingElement': 'Drilling',
    'DrillingInline': '· drilling',
    'EditNote': 'Edit note',
    'EndPlan': 'End plan',
    'EndPlanConfirmCopy': 'Your progress so far is kept and you can start again anytime. Auto-tracking and recording retention stop.',
    'EndPlanConfirmTitle': 'End your plan?',
    'EndPlanError': 'Could not end your plan.',
    'Ending': 'Ending…',
    'GoBackAWeek': 'Go back a week',
    'GoBackConfirmCopy': 'This discards this week’s practices and restarts last week from scratch — its recordings will be permanently deleted. This can’t be undone.',
    'GoBackConfirmTitle': 'Go back one week?',
    'GoBackError': 'Could not go back a week.',
    'Heading': 'Progress',
    'HistoryCurrentPlan': 'Current plan · started {Date}',
    'HistoryPreviousPlan': 'Previous plan · {Range}',
    'HistoryRepsSuffix': 'reps',
    'KeepError': 'Could not save that take to your library.',
    'KeepNeedsPremium': 'Saving a take to your library needs Premium.',
    'Kicker': 'Mastery spine',
    'LastDayThisWeek': 'Last day this week',
    'Lead': 'Track the 12-Week Plan and the 4 Stages of Learning — pick one element, drill it for seven days, record-and-review, and advance.',
    'LifetimeRepMany': 'lifetime reps',
    'LifetimeRepOne': 'lifetime rep',
    'LoadError': 'Couldn’t load your progress.',
    'LoadErrorToast': 'Failed to load your progress.',
    'LoadPlayback': 'Load playback',
    'Loading': 'Loading your progress…',
    'MasteryElement.EyeContact': 'Eye contact',
    'MasteryElement.FacialExpression': 'Facial expression',
    'MasteryElement.Gesture': 'Gesture',
    'MasteryElement.Pause': 'Pause',
    'MasteryElement.PitchAndMelody': 'Pitch & melody',
    'MasteryElement.RateOfSpeech': 'Rate of speech',
    'MasteryElement.Tonality': 'Tonality',
    'MasteryElement.Volume': 'Volume',
    'MetaDescription': 'Progress — the 12-week plan and the four stages of learning that thread the VoiceDojo practices.',
    'NoRecordingRetained': 'No recording retained.',
    'NoRepSessions': 'No rep sessions recorded for this week.',
    'NoRepsHint': 'No reps yet — pass the halfway mark of any practice and it lands here.',
    'NoWeeksHint': 'No weeks completed yet — your finished weeks land here.',
    'NotePlaceholder': 'A quick note to your future self…',
    'OneDayLeft': '{Days} day left this week',
    'PickElementHint': 'Pick the element you’ll drill this week:',
    'PlanComplete': 'Plan complete — all {Weeks} weeks done. 🎉',
    'PlanGroupCurrent': 'Current plan',
    'PlanGroupHeld': 'Previous plan — held',
    'PlanHistoryHeading': 'Plan history',
    'PlanStarted': 'Started {Date}',
    'PlanStartedNotice': 'Your plan started on {Date} — plans start automatically with your first practice. While it’s active, completed takes are saved to your library for the plan; end it anytime with End plan below.',
    'PlanTakeActionError': 'Something went wrong with that take. Please try again.',
    'PlanTakesHeading': 'Takes in this plan',
    'Plans.BackToProgress': '‹ Back to Progress',
    'Plans.EmptyBody': 'Start the 12-Week Plan and it will show up here.',
    'Plans.EmptyHeading': 'No plans yet',
    'Plans.GoToProgress': 'Go to Progress',
    'Plans.Heading': 'My plans',
    'Plans.Lead': 'Every 12-Week Plan you have had or are having, newest first.',
    'Plans.LoadError': 'We couldn\'t load your plans.',
    'Plans.Loading': 'Loading your plans…',
    'Plans.StatusActive': 'Active',
    'Plans.StatusCompleted': 'Completed',
    'Plans.StatusEndedEarly': 'Ended early',
    'Plans.WeeksCompletedMany': '{Weeks} weeks completed',
    'Plans.WeeksCompletedOne': '{Weeks} week completed',
    'RepCountMany': 'reps',
    'RepCountOne': 'rep',
    'RepHalfwayHint': 'A practice counts as a rep once you pass its halfway mark. More reps → better.',
    'RepTargetToAdvance': 'Reach {Target} reps this week to move {Element} up a stage.',
    'RepsByDayAria': 'Reps by day of the week',
    'RepsHeading': 'Reps',
    'RepsThisWeekAria': 'Reps this week toward the weekly target',
    'RetainedCompetence': '{Count} of {Total} elements past unconscious incompetence',
    'RetainedHeading': 'What you keep',
    'RetainedReps': '{Count} lifetime rep(s)',
    'Save': 'Save',
    'SaveNoteError': 'Could not save your note.',
    'Saving': 'Saving…',
    'SelectError': 'Could not select that element.',
    'StageHeldBelowTarget': 'Below {Target} reps, stage held.',
    'StagesHeading': '4 Stages of Learning',
    'StagesHint': 'Competence per element, climbing from unconscious incompetence to unconscious competence.',
    'StartCardBody': 'The mastery spine threads the Mastery practices. Begin the plan, pick one element to drill each week, and climb the four stages of learning.',
    'StartCardHeading': 'Start your 12-Week Plan',
    'StartError': 'Could not start your plan.',
    'StartNewPlan': 'Start a new plan',
    'StartPlan': 'Start the plan',
    'Starting': 'Starting…',
    'TakeLabel': '{Practice} · {Title}',
    'Target': 'target',
    'ThisWeekHeading': 'This week',
    'ThisWeeksElement': 'This week’s element',
    'ThisWeeksRecordings': 'This week’s recordings',
    'ThisWeeksReps': 'This week’s reps',
    'Title': 'Progress · VoiceDojo',
    'TryAgain': 'Try again',
    'Validations.RequiresPremium': 'Progress is a Premium feature. Upgrade to Premium to track your 12-week mastery plan.',
    'WeekDates': 'Week {Week} · {Range}',
    'WeekNow': 'Week {Week}',
    'WeekOf': 'of {Total}',
    'WeekRepsSelfReviewedMany': '{Reps} reps · {Count} fully self-reviewed',
    'WeekRepsSelfReviewedOne': '{Reps} rep · {Count} fully self-reviewed',
    'WeekStateAhead': 'ahead',
    'WeekStateCurrent': 'now',
    'WeekStateDone': 'done',
    'WeekTitle': 'Week {Week}',
    'WeekTrackHeading': 'The 12-week plan',
    'WeeksCompletedAria': 'Weeks completed',
    'WeeksDrilledSuffix': 'w',
  },
  'vi-VN': {
    'AbandonedHint': 'Tự động theo dõi và lưu giữ bản thu đang tạm dừng. Bắt đầu kế hoạch mới bất cứ lúc nào; mức thành thạo và tổng số lần luyện của bạn được chuyển tiếp.',
    'AbandonedStatus': 'Đã kết thúc kế hoạch — tiến trình của bạn đến nay được giữ lại.',
    'AcrossPracticesMany': 'bài luyện',
    'AcrossPracticesOne': 'bài luyện',
    'AcrossPrefix': 'trên',
    'AddNote': 'Thêm ghi chú',
    'AiReview': 'Đánh giá AI',
    'AllMyPlans': 'Tất cả kế hoạch của tôi ›',
    'AutoAdvanceNote': 'Tuần của bạn tự động tiến lên sau 7 ngày — cứ tiếp tục luyện tập.',
    'Cancel': 'Hủy',
    'CurrentPlanDates': 'Bắt đầu {Date} · Tuần {Week} · {Range}',
    'DayDotsAria': 'Số ngày đã tập trong tuần này',
    'DayFallback': 'Ngày {Number}',
    'DayFri': 'T6',
    'DayMon': 'T2',
    'DaySat': 'T7',
    'DaySun': 'CN',
    'DayThu': 'T5',
    'DayTue': 'T3',
    'DayWed': 'T4',
    'DaysLeft': 'Còn {Days} ngày trong tuần này',
    'DaysLeftAria': 'Số ngày còn lại trong tuần này',
    'DaysPractised': '{Days} trên {Total} ngày',
    'DaysPractisedHint': 'Một ngày được tính khi bạn vượt qua nửa chặng của bất kỳ bài tập nào.',
    'Discard': 'HỦY BỎ',
    'Discarding': 'Đang hủy bỏ…',
    'DrillingElement': 'Đang luyện',
    'DrillingInline': '· đang luyện',
    'EditNote': 'Sửa ghi chú',
    'EndPlan': 'Kết thúc kế hoạch',
    'EndPlanConfirmCopy': 'Tiến trình của bạn đến nay được giữ lại và bạn có thể bắt đầu lại bất cứ lúc nào. Tự động theo dõi và lưu giữ bản thu sẽ dừng.',
    'EndPlanConfirmTitle': 'Kết thúc kế hoạch của bạn?',
    'EndPlanError': 'Không thể kết thúc kế hoạch của bạn.',
    'Ending': 'Đang kết thúc…',
    'GoBackAWeek': 'Quay lại một tuần',
    'GoBackConfirmCopy': 'Việc này hủy các bài luyện của tuần này và khởi động lại tuần trước từ đầu — các bản thu của nó sẽ bị xóa vĩnh viễn. Không thể hoàn tác.',
    'GoBackConfirmTitle': 'Quay lại một tuần?',
    'GoBackError': 'Không thể quay lại một tuần.',
    'Heading': 'Tiến trình',
    'HistoryCurrentPlan': 'Kế hoạch hiện tại · bắt đầu {Date}',
    'HistoryPreviousPlan': 'Kế hoạch trước · {Range}',
    'HistoryRepsSuffix': 'lần',
    'KeepError': 'Không thể lưu lượt đó vào thư viện của bạn.',
    'KeepNeedsPremium': 'Lưu một lượt vào thư viện của bạn cần Cao cấp.',
    'Kicker': 'Trục thành thạo',
    'LastDayThisWeek': 'Ngày cuối của tuần này',
    'Lead': 'Theo dõi Kế hoạch 12 tuần và 4 Giai đoạn Học tập — chọn một yếu tố, luyện nó trong bảy ngày, ghi-và-đánh-giá, rồi tiến lên.',
    'LifetimeRepMany': 'lần luyện trọn đời',
    'LifetimeRepOne': 'lần luyện trọn đời',
    'LoadError': 'Không thể tải tiến trình của bạn.',
    'LoadErrorToast': 'Không tải được tiến trình của bạn.',
    'LoadPlayback': 'Tải bản phát lại',
    'Loading': 'Đang tải tiến trình của bạn…',
    'MasteryElement.EyeContact': 'Giao tiếp bằng mắt',
    'MasteryElement.FacialExpression': 'Biểu cảm khuôn mặt',
    'MasteryElement.Gesture': 'Cử chỉ',
    'MasteryElement.Pause': 'Khoảng lặng',
    'MasteryElement.PitchAndMelody': 'Cao độ & giai điệu',
    'MasteryElement.RateOfSpeech': 'Tốc độ nói',
    'MasteryElement.Tonality': 'Sắc thái',
    'MasteryElement.Volume': 'Âm lượng',
    'MetaDescription': 'Tiến trình — kế hoạch 12 tuần và bốn giai đoạn học tập xuyên suốt các bài luyện của VoiceDojo.',
    'NoRecordingRetained': 'Không có bản thu nào được giữ lại.',
    'NoRepSessions': 'Không có phiên luyện nào được ghi cho tuần này.',
    'NoRepsHint': 'Chưa có lần luyện nào — vượt qua mốc giữa của bất kỳ bài luyện nào và nó sẽ xuất hiện ở đây.',
    'NoWeeksHint': 'Chưa hoàn thành tuần nào — các tuần đã xong của bạn sẽ xuất hiện ở đây.',
    'NotePlaceholder': 'Một ghi chú nhanh cho bản thân tương lai của bạn…',
    'OneDayLeft': 'Còn {Days} ngày trong tuần này',
    'PickElementHint': 'Chọn yếu tố bạn sẽ luyện trong tuần này:',
    'PlanComplete': 'Hoàn thành kế hoạch — đã xong cả {Weeks} tuần. 🎉',
    'PlanGroupCurrent': 'Kế hoạch hiện tại',
    'PlanGroupHeld': 'Kế hoạch trước — đang giữ',
    'PlanHistoryHeading': 'Lịch sử kế hoạch',
    'PlanStarted': 'Bắt đầu {Date}',
    'PlanStartedNotice': 'Kế hoạch của bạn bắt đầu vào {Date} — kế hoạch tự động bắt đầu với buổi luyện tập đầu tiên. Trong khi kế hoạch đang hoạt động, các bản thu hoàn chỉnh được lưu vào thư viện cho kế hoạch; bạn có thể kết thúc bất cứ lúc nào bằng Kết thúc kế hoạch bên dưới.',
    'PlanTakeActionError': 'Đã xảy ra lỗi với lượt đó. Vui lòng thử lại.',
    'PlanTakesHeading': 'Các lượt trong kế hoạch này',
    'Plans.BackToProgress': '‹ Quay lại Tiến trình',
    'Plans.EmptyBody': 'Bắt đầu Kế hoạch 12 tuần và nó sẽ xuất hiện ở đây.',
    'Plans.EmptyHeading': 'Chưa có kế hoạch nào',
    'Plans.GoToProgress': 'Đến Tiến trình',
    'Plans.Heading': 'Kế hoạch của tôi',
    'Plans.Lead': 'Mọi Kế hoạch 12 tuần bạn đã có hoặc đang có, mới nhất trước.',
    'Plans.LoadError': 'Chúng tôi không thể tải các kế hoạch của bạn.',
    'Plans.Loading': 'Đang tải các kế hoạch của bạn…',
    'Plans.StatusActive': 'Đang hoạt động',
    'Plans.StatusCompleted': 'Đã hoàn thành',
    'Plans.StatusEndedEarly': 'Kết thúc sớm',
    'Plans.WeeksCompletedMany': 'Đã hoàn thành {Weeks} tuần',
    'Plans.WeeksCompletedOne': 'Đã hoàn thành {Weeks} tuần',
    'RepCountMany': 'lần',
    'RepCountOne': 'lần',
    'RepHalfwayHint': 'Một bài luyện được tính là một lần khi bạn vượt qua mốc giữa. Càng nhiều lần → càng tốt.',
    'RepTargetToAdvance': 'Đạt {Target} lần tập trong tuần này để nâng {Element} lên một giai đoạn.',
    'RepsByDayAria': 'Số lần luyện theo từng ngày trong tuần',
    'RepsHeading': 'Số lần luyện',
    'RepsThisWeekAria': 'Số lần luyện trong tuần so với mục tiêu hàng tuần',
    'RetainedCompetence': '{Count} trên {Total} yếu tố đã vượt qua vô thức kém cỏi',
    'RetainedHeading': 'Những gì bạn giữ lại',
    'RetainedReps': '{Count} lượt tập tích luỹ',
    'Save': 'Lưu',
    'SaveNoteError': 'Không thể lưu ghi chú của bạn.',
    'Saving': 'Đang lưu…',
    'SelectError': 'Không thể chọn yếu tố đó.',
    'StageHeldBelowTarget': 'Dưới {Target} lần tập, giữ nguyên giai đoạn.',
    'StagesHeading': '4 Giai đoạn Học tập',
    'StagesHint': 'Mức thành thạo theo từng yếu tố, leo từ vô thức kém cỏi đến vô thức thành thạo.',
    'StartCardBody': 'Trục thành thạo kết nối các bài luyện Mastery. Bắt đầu kế hoạch, chọn một yếu tố để luyện mỗi tuần, và leo qua bốn giai đoạn học tập.',
    'StartCardHeading': 'Bắt đầu Kế hoạch 12 tuần của bạn',
    'StartError': 'Không thể bắt đầu kế hoạch của bạn.',
    'StartNewPlan': 'Bắt đầu kế hoạch mới',
    'StartPlan': 'Bắt đầu kế hoạch',
    'Starting': 'Đang bắt đầu…',
    'TakeLabel': '{Practice} · {Title}',
    'Target': 'mục tiêu',
    'ThisWeekHeading': 'Tuần này',
    'ThisWeeksElement': 'Yếu tố của tuần này',
    'ThisWeeksRecordings': 'Bản thu của tuần này',
    'ThisWeeksReps': 'Số lần luyện của tuần này',
    'Title': 'Tiến trình · VoiceDojo',
    'TryAgain': 'Thử lại',
    'Validations.RequiresPremium': 'Tiến trình là tính năng Cao cấp. Hãy nâng cấp lên Cao cấp để theo dõi kế hoạch thành thạo 12 tuần của bạn.',
    'WeekDates': 'Tuần {Week} · {Range}',
    'WeekNow': 'Tuần {Week}',
    'WeekOf': 'trên {Total}',
    'WeekRepsSelfReviewedMany': '{Reps} lần · {Count} đã tự đánh giá đầy đủ',
    'WeekRepsSelfReviewedOne': '{Reps} lần · {Count} đã tự đánh giá đầy đủ',
    'WeekStateAhead': 'phía trước',
    'WeekStateCurrent': 'hiện tại',
    'WeekStateDone': 'xong',
    'WeekTitle': 'Tuần {Week}',
    'WeekTrackHeading': 'Kế hoạch 12 tuần',
    'WeeksCompletedAria': 'Số tuần đã hoàn thành',
    'WeeksDrilledSuffix': 't',
  },
} as const;

